import { useApiMutation } from '@/modules/common';

interface CreatePromptPayload {
  content: string;
  categoryId: string;
  notes: string;
}

export function useCreatePrompt() {
  const createPromptMutation = useApiMutation<CreatePromptPayload>(
    '/system-prompts',
    { method: 'POST' }
  );

  return { createPromptMutation } as const;
}
